import React from 'react'
import './buttons.css'
import SubjectToCSSName from '../../../core/less/SubjectToCSSName'

function asButton(WrappedComponent, buttonClassName, disabledClassName) {
  return ({disabled, className, fullwidth, subjectColorId, ...rest}) => {
    const classNames = [buttonClassName]
    if (fullwidth) {
      classNames.push('button--fullwidth')
    }
    if (subjectColorId) {
      classNames.push(`button--${SubjectToCSSName[subjectColorId]}`)
    }
    if (disabled) {
      classNames.push(disabledClassName, className)
      const {onClick, to, href, ...others} = rest
      return (<div className={classNames.join(' ')} {...others} />)
    } else {
      classNames.push(className)
      return (<WrappedComponent className={classNames.join(' ')} {...rest} />)
    }
  }
}


export function asPrimaryButton(WrappedComponent) {
  const buttonClassName = `button button--primary`
  const disabledClassName = `button--primary--disabled`
  return asButton(WrappedComponent, buttonClassName, disabledClassName)

}

export function asSecondaryButton(WrappedComponent) {
  const buttonClassName = `button button--secondary`
  const disabledClassName = `button--secondary--disabled`
  return asButton(WrappedComponent, buttonClassName, disabledClassName)
}

export function asSecondaryButtonInverted(WrappedComponent) {
  const buttonClassName = `button button--secondary--inverted`
  const disabledClassName = `button--secondary--disabled--inverted`
  return asButton(WrappedComponent, buttonClassName, disabledClassName)
}

export function asTertiaryButton(WrappedComponent, light) {
  let buttonClassName = `button button--tertiary`
  if (light) {
    buttonClassName = `${buttonClassName}--light`
  } else {
    buttonClassName = `${buttonClassName}--dark`
  }
  const disabledClassName = `button--tertiary--disabled`
  return asButton(WrappedComponent, buttonClassName, disabledClassName)
}

export function asBorderlessButton(WrappedComponent, light) {
  let buttonClassName = `button button--borderless`
  if (light) {
    buttonClassName = `${buttonClassName}--light`
  } else {
    buttonClassName = `${buttonClassName}--dark`
  }
  const disabledClassName = `button--borderless--disabled`
  return asButton(WrappedComponent, buttonClassName, disabledClassName)
}

export function asSubjectButton(WrappedComponent) {
  const buttonClassName = `button button--primary`
  const disabledClassName = `button--primary--disabled`
  return asButton(WrappedComponent, buttonClassName, disabledClassName)

}



// WEBPACK FOOTER //
// ./src/core/components/button/index.js